//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Routing/Routing.SelectLineSegment.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"ConvertEccentricSegment",1,0],[1,"Length",0,"Expression",0],[1,"LineSelection",0,"Routing.SelectLineSegment",0],[0,"LockLength",1,0],[0,"ReverseDirection",1,0]],[[["start_point","direction"],"GetOrientation",{R_:{is_valid:''}},0,0],[["line"],"InitializeFromLine",{},1,0],[[],"DragLineLength",{},0,0],[[],"ModifiedLineLength",{},0,0],[[],"StopDrag",{},0,0],[[],"RestartDrag",{},0,0],[[],"GetActiveRcpPositon",{R_:{activeRcpPosition:''}},0,0],[[],"DetachActiveRcp",{},0,0],[[],"AddLineToSetOfAllEditedSegments",{},0,0]],[]];
SPLM.Routing.EditLineSegmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.EditLineSegmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;